/**
 * Hands a generated text file to the browser as a download (no network involved).
 *
 * @param {string} fileName
 * @param {string} content
 * @param {string} [mimeType]
 */
export function downloadTextFile(fileName, content, mimeType = 'text/csv;charset=utf-8') {
  const url = URL.createObjectURL(new Blob([content], { type: mimeType }));
  const link = document.createElement('a');
  link.href = url;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  link.remove();
  // Revoked on the next tick: Firefox and Safari can cancel the download if it is released synchronously.
  setTimeout(() => URL.revokeObjectURL(url), 0);
}
